const fonts = {
  alt: 'ibm-plex-mono, sans-serif'
}

export default fonts;